"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const getters_1 = __importDefault(require("./getters"));
const mutations_1 = __importDefault(require("./mutations"));
const actions_1 = __importDefault(require("./actions"));
const state_1 = __importDefault(require("./state"));
const store = {
    state: (0, vue_1.readonly)(state_1.default),
    getters: getters_1.default,
    mutations: mutations_1.default,
    actions: actions_1.default
};
exports.default = store;
